import Alpine from "alpinejs";
import htmx from "htmx.org";

window.htmx = htmx;
window.Alpine = Alpine;
Alpine.start();

function formatNumber(number) {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);
}

const currencyByClass = () => {
  const numberElements = document.querySelectorAll(".currency");
  numberElements.forEach((el) => {
    const number = parseFloat(el.getAttribute("data-price"));
    el.textContent = formatNumber(number);
  });
};

document.addEventListener("DOMContentLoaded", currencyByClass);
document.addEventListener("htmx:load", currencyByClass);
